<style >
.card-actions-bottom {
  position: absolute;
  bottom: 0;
  width:100%;
}

.xl.v-input input {
  max-height: 100px !important;
  font-size: 30px;
  line-height: 30px;
}
</style>
<template>
  <v-app>
    <!-- <v-btn fab fixed bottom right class='mb-2' color='primary' >
    <v-icon>mdi-plus</v-icon>
  </v-btn> -->
    <v-navigation-drawer v-if='isLoggedIn && !iframe' v-model='sidebar' dark app>
      <v-toolbar dense flat dark>
        <v-icon color='amber' small class='mr-2'>mdi-cog</v-icon>
        <v-toolbar-title>
          <span class='red--text font-weight-medium darken-3'>Guru</span>Config
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click='sidebar=false' icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-list dense>
        <v-list-item :href='LINKS.APP' class='mr-3'>
          <v-list-item-content>
            <v-list-item-title>
              <v-icon small>mdi-arrow-left</v-icon>
              Return to app
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <template v-for='navitem in navitems' >
          <template v-if="!navitem.hideFromDependents || isDependent===false" >
            {{navitem.hideFromDependents}}
            <v-subheader v-if='navitem.type === "subheader"' :key='navitem.text' v-text='navitem.text' />
            <v-list-item v-else exact
              :to='navitem.path'
              :key='navitem.id'
              :class='navitem.klass'
              class='mr-3' >
              <v-list-item-content>
                <v-list-item-title v-text='navitem.text' />
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
        <!-- <v-subheader >
        Missions
        <v-chip color="amber" class='ml-4 justify-right' small dark >
          Coming soon
        </v-chip>
      </v-subheader> -->
      </v-list>
      <v-card-text v-if="spacesIOwn.length > 0" >
        <v-btn @click='launchInviteWizard' small block outlined>
          Add teammates
        </v-btn>
      </v-card-text>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn @click='logout' block>Logout</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar v-if='isLoggedIn && !iframe' dense flat color='orange' app dark>
      <v-icon @click='sidebar=!sidebar' class='mr-2'>mdi-menu</v-icon>
      <v-btn text to='/'>AppointmentGuru.</v-btn>
      <v-chip class='ml-2 d-none d-sm-flex' label small color='teal'>settings</v-chip>
      <!-- <v-chip class='ml-2 d-none d-sm-flex' label small color='amber' >Early Access</v-chip> -->

      <v-btn text small
        v-for="page in topLevelPages"
        :key="page.to"
        :to="page.to" >{{page.title}}</v-btn>

      <v-spacer></v-spacer>

      <template v-if='isLoggedIn'>
        <v-divider vertical></v-divider>
        <v-btn v-if='meId' @click='init' small text>
          <v-progress-circular indeterminate v-if='globalInitLoading' width='2' class='mr-2' size='32' />
          <v-avatar v-else :size='32' class='mr-2' color='white'>
            <img v-if='meProfile' :src="meProfile" />
            <span v-else class='black--text'>{{ meInitials }}</span>
          </v-avatar>
          {{meFullname}}
        </v-btn>
      </template>

      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn v-on='on' slot='activator' small icon>
            <v-icon >mdi-apps</v-icon>
          </v-btn>
        </template>
        <v-card width="300">
          <v-card-title class='py-1 overline justify-center'>
            AppointmentGuru Apps
            <v-spacer />
            <v-btn icon small>
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4" class="text-center">
                <v-btn href="https://app.appointmentguru.co" icon>
                  <img src="/img/icons/favicon-16x16.png" />
                </v-btn>
                <div class="caption">App</div>
              </v-col>
              <v-col cols="4" class="text-center">
                <v-btn href="https://settings.appointmentguru.co" icon>
                  <v-icon large color="blue">mdi-cog</v-icon>
                </v-btn>
                <div class="caption">Settings</div>
              </v-col>
              <v-col v-if="spacesIOwn.length > 0" cols="4" class="text-center">
                <v-btn href="https://dashboard.appointmentguru.co" icon>
                  <v-icon large color="amber">mdi-chart-box</v-icon>
                </v-btn>
                <div class="caption">Numbers</div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-footer>
            <v-spacer />
            <v-btn @click="logout" x-small text>Logout
              <v-icon small class="ml-1">mdi-logout</v-icon>
            </v-btn>
          </v-footer>
        </v-card>
      </v-menu>
    </v-app-bar>

    <request-status :message200="false" :request='global.request.me' />
    <request-status :message200="false" :request='global.request.lookups' />

    <!-- Sizes your content based upon application components -->
    <v-main class='grey lighten-2'>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-dialog v-if='activeDialog' v-model='showDialog' v-bind='activeDialog.attrs'>
      <v-card>
        <v-toolbar dense flat dark color='orange'>
          <v-toolbar-title v-text='activeDialog.title'></v-toolbar-title>
          <v-spacer />
          <v-btn @click='showDialog = false' icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- <pre v-text='activeDialog' /> -->
        <v-component
          :is='dialogComponent'
          v-bind='activeDialog.componentAttrs'
          @saved='globalDialogSaveEvent'
          @close='showDialog=false' />
      </v-card>
    </v-dialog>
    <v-footer app class='caption'>
      <v-icon small color='amber' class='mr-2'>mdi-star</v-icon>
      Build your brand with
      <strong to='/' text class='ml-1'> AppointmentGuru</strong>
      <v-spacer />
      <version />
    </v-footer>

    <v-dialog v-model='showVideo'>
      <v-card dark>
        <v-card-title>
          <v-spacer />
          <v-btn @click='showVideo=false' icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <div style="position: relative; padding-bottom: 62.5%; height: 0;">
          <iframe src="https://www.loom.com/embed/acb833c5c2654a96a484d9e8f2cb5979" frameborder="0"
            webkitallowfullscreen mozallowfullscreen allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
          </iframe>
        </div>
      </v-card>
    </v-dialog>

    <v-speed-dial v-model="fab" fixed bottom right class="mb-5" >
      <template v-slot:activator>
        <v-btn dark fab v-model="fab" color="blue darken-2" >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-plus
          </v-icon>
        </v-btn>
      </template>

      <v-btn @click="launchInviteWizard" fab dark small color="primary" >
        <v-icon>mdi-account-plus-outline</v-icon>
      </v-btn>
      <v-btn @click="launchNewSpaceWizard" fab dark small color="success" >
        <v-icon>mdi-office-building-plus-outline</v-icon>
      </v-btn>
      <!-- <v-btn @click="launchQuickCreateAppointmentType" fab dark small color="success" >
        <v-icon>mdi-star</v-icon>
      </v-btn> -->
    </v-speed-dial>

  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import {LINKS} from '@/store/constants.js'
import ComponentRegistry from '@/components/registry.js'
import Version from '@/components/ui/Version.vue'

export default {
  name: 'App',
  components: {Version},
  data: () => ({
    sidebar: null,
    showVideo: false,
    speeddial: false,
    LINKS: LINKS,
    fab: false
  }),
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn', 'auth'
    ]),
    ...mapGetters('identity', [
      'me',
      'meId',
      'meFullname',
      'meProfile',
      'meInitials',
    ]),
    dialogComponent () {
      let componentId = this.getObjectPath(this.activeDialog, 'id')
      if (componentId) {
        if (componentId in ComponentRegistry) {
          return ComponentRegistry[componentId].component
        } else {
          console.error(`${componentId} is not registerd in @/components/registry.js`)
        }
      }
      return null
    },
    activeDialog () {
      return this.$store.getters.activeDialog
    },
    showDialog: {
      get: function () {
        return this.$store.getters.activeDialog.visible
      },
      set: function (isVisible) {
        this.$store.commit('setDialogVisible', isVisible)
      }
    },
    navitems () {
      let spaceItems = [
        { type: 'subheader', text: 'Spaces' },
        { id: 'spaces-home', text: 'Spaces', path: '/settings/spaces', exact: true },
        { id: 'spaces-settings', text: 'Settings', path: '/settings/spaces/--/settings', klass: 'ml-2' },
        { id: 'spaces-team', text: 'Team', path: '/settings/spaces/--/team', klass: 'ml-2' },
        { id: 'spaces-locations', text: 'Locations', path: '/settings/spaces/--/locations', klass: 'ml-2' },
        { id: 'spaces-appointment-types', text: 'Appointment Types', path: '/settings/spaces/--/appointment-types', klass: 'ml-2' }
      ]

      let profileItems = [
        { type: 'subheader', text: 'Account' },
        { id: 'profile', text: 'Profile', path: '/settings/me/profile' },
        { id: 'profile-appointment-type', text: 'Appointment Types', path: '/settings/me/appointment-types', klass: 'ml-2' },
        { id: 'profile-rules', path: '/settings/me/rules', text: 'Rules', klass: 'ml-2' },
        { id: 'profile-hours', path: '/settings/me/hours', text: 'Hours', klass: 'ml-2' },
        // { id: 'billing', path: '/settings/billing', text: 'Billing' }
        { id: 'profile-notifications', path: '/settings/me/notifications', text: 'Notifications', klass: 'ml-2' }
      ]

      let tools = [
        { type: 'subheader', text: 'Tools' },
        { id: 'tools-update-pricing', path: '/tools/update-pricing', text: 'Update pricing' },
      ]

      // let pages = []

      let commonItems = [
        { id: 'home', text: 'Home', path: '/' }
      ]
      // { id: 'operating-hours', path: '/settings/me/operating-hours', text: 'Operating  Hours' },

      // { id: 'billing', path: '/tools/billing', text: 'Billing' },
      // { type: 'subheader', text: 'Tools' },
      // { id: 'tools-suggest', path: '/tools/suggest', text: 'Configuration suggestions' },
      // { id: 'tools-convert', path: '/tools/convert-space', text: 'Convert Service to location' },
      // { id: 'mobile', path: '/tools/app', text: 'Mobile Apps' },
      // { id: 'free-stuff', path: '/tools/free-stuff', text: 'Free stuff & rewards' }
      // { type: 'subheader', text: 'Missions' },

      if (this.spacesIOwn.length > 0) {
        let extraItems = [
          { id: 'brand', text: 'Brand', path: '/brand' },
          { id: 'team', text: 'Team', path: '/settings/team' }
        ]
        // console.log(spaceItems)
        return commonItems.concat(extraItems).concat(spaceItems).concat(profileItems).concat(tools)
      } else {
        let spaceItems = []
        // let spaceItems = [
        //   { type: 'subheader', text: 'Spaces' },
        //   { id: 'spaces-home', text: 'Spaces', path: '/settings/spaces', exact: true }
        // ]
        return commonItems.concat(spaceItems).concat(profileItems) // .concat(tools)
      }
    },
    iframe() {
      return this.getObjectPath(this.$route, 'query.frame') === 'i'
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logUserOut')
      this.$router.push({path: '/login'})
    },
    globalDialogSaveEvent (data) {
      let key = this.$store.getters.activeDialog.id
      this.$store.commit('setEvent', {key, data})
    }
  },
  watch: {
    isLoggedIn: {
      immediate: true,
      handler () {
        if (this.isLoggedIn) {
          this.init()
        }
      }
    }
  }
};
</script>
